<abp-modal-header
    [title]=" title | localize"
    (onCloseClick)="bsModalRef.hide()"
  ></abp-modal-header>
  <div class="modal-body">
    <qrcode #parent
        [elementType]="type" 
        [qrdata]="value"
        width="466"
        errorCorrectionLevel="L"
        (qrCodeURL)="onChangeURL($event)">
    </qrcode>
    <p class="text-center">
      <a [href]="[value]" [title]="'TargetLink' | localize" target="_blank">{{ value }} <i class="fa fa-external-link"></i></a>
    </p>
    <a class="btn btn-default btn-block" [href]="qrCodeDownloadLink" [download]="title">Download QR Code Image</a>
  </div>